module.exports = __webpack_public_path__ + "static/Gotham-Ultra-2f974201ddd0c887584ff5f4d57be0e1.ttf";